<template>
  <nav>
    <div v-show="totalPages > 0" class="paginacion-catalogo mt-5 mx-4">
      <div class="pagination-buttons">
        <button type="button" :disabled="currentPage == 1" @click="controls(-1)" class="buttonText">
          <v-icon v-if="$vuetify.breakpoint.xs">mdi-chevron-left</v-icon>
          <span v-if="$vuetify.breakpoint.smAndUp">Anterior</span>
        </button>
        <button
            type="button"
            v-for="(page, index) in pagesToShow"
            :key="index"
            @click="changePage(page)"
            :class="{ active: page === value }"
            class="buttonPage"
        >
          {{ page }}
        </button>
        <button type="button" :disabled="currentPage === totalPages" @click="controls(1)" class="buttonText">
          <v-icon v-if="$vuetify.breakpoint.xs">mdi-chevron-right</v-icon>
          <span v-if="$vuetify.breakpoint.smAndUp">Siguiente</span>
        </button>
      </div>
      <v-select
        :items="itemsPorPagina"
        v-model="porPagina"
        dense
        outlined
        hide-details
        class="select-minimal centered-select"
        :menu-props="{ offsetY: true, bottom: true, nudgeBottom: $vuetify.breakpoint.sm ? 40 : 0 }"
        @change="emitPerPage"
      ></v-select>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    itemsPorPagina: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      totalVisible: 3,
      porPagina: this.perPage || 5,
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.value;
      },
      set(newPage) {
        this.$emit("update:value", newPage);
      },
    },
    pagesToShow() {
      const currentPage = this.value;
      const total = this.totalPages;
      const totalVisible = this.totalVisible;
      const halfVisible = Math.floor(totalVisible / 2);
      let from = currentPage - halfVisible;
      let to = currentPage + halfVisible;

      // Asegurar que las páginas mostradas estén dentro del rango válido
      if (from < 1) {
        from = 1;
        to = Math.min(totalVisible, total);
      }
      if (to > total) {
        to = total;
        from = Math.max(1, total - totalVisible + 1);
      }

      // Crear un array con las páginas que se mostrarán

      const pages = [];
      if (from > 1) {
        pages.push(1);
        if (from > 2) {
          pages.push("..."); // Agregar puntos suspensivos al principio o al final
        }
      }
      for (let i = from; i <= to; i++) {
        pages.push(i);
      }
      if (to < total) {
        if (to < total - 1) {
          pages.push("..."); // Agregar puntos suspensivos  al final
        }
        pages.push(total);
      }
      return pages;
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.$emit("page-changed", newValue, oldValue);
    },
    perPage(newValue) {
        this.porPagina = newValue
    }
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.value) {
        this.$emit("update:value", page);
      }
    },
    controls(variable) {
      const newPage = this.value + variable;
      if (newPage >= 1 && newPage <= this.totalPages) {
        this.$emit("update:value", newPage);
      }
    },
    emitPerPage(valor) {
      this.$emit("per-page-changed", valor);
    },
  },
};
</script>

<style scoped>
/* Estilos opcionales para dar formato a la paginación */
.paginacion-catalogo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 3px;
}

@media (min-width: 600px) {
  .paginacion-catalogo {
    flex-direction: row;
    gap: 3px;
  }
}

.pagination-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-bottom: 5px;
}

@media (min-width: 600px) {
  .pagination-buttons {
    width: auto;
    margin-bottom: 0;
  }
}

.paginacion-catalogo, .buttonText {
  color: black;
  border: none;
  cursor: pointer;
  padding: 3px 10px !important;
  margin: 0 5px;
}

.buttonText {
  background-color: transparent;
}

.paginacion-catalogo, .buttonText {
  color: black;
  border: none;
  cursor: pointer;
  padding: 3px 10px !important;
  margin: 0 5px;
}

.buttonPage {
  background: #ffffff;
  border-radius: 10px !important;
  box-shadow: 0 2px 2px rgb(213, 211, 211);
  padding: 3px 8px !important;   /* MÁS PEQUEÑO → SE ENCOGE */
  
}

/* hover */
.paginacion-catalogo button:not(.active):hover {
  background-color: #1C1E4D;
  color: white;
  border-radius: 10px !important;
}

.paginacion-catalogo button.active {
  background-color: #1C1E4D;
  color: white;
  border-radius: 10px !important;
}

.paginacion-catalogo button:disabled {
  pointer-events: none;
  opacity: 0.6;
}

.select-minimal {
  max-width: 75px !important;   /* ancho compacto */
  min-width: 75px !important;
  width: 100%;
}

@media (min-width: 600px) {
  .select-minimal {
    width: auto;
    flex-shrink: 0;
  }
}

:deep(.v-input__control) {
  min-height: 32px !important;  /* igual altura que botones */
  border-color: #1C1E4D !important;
  border-radius: 8px;
  background-color: white !important;
  box-shadow: 0 2px 2px  rgb(213, 211, 211);
}

:deep(.v-input__slot) {
  padding: 0 4px !important;
}

:deep(input) {
  display: none;
}

:deep(.v-input__append-inner).select-minimal  .v-input__append-inner {
  margin-right: 2px !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}
:deep(.v-select__selections) {
   width: 100%;
  display: flex;
  justify-content: center !important;
  margin-left: 7px !important;
}

</style>
